import { Cancel, ExpandLess, ExpandMore } from "@mui/icons-material";
import { Divider, IconButton } from "@mui/material";
import client from "../../assets/images/client-image.png";
import './Maintenance.css'
import { useState } from "react";

const RequestProfile = ({ analysis, setOpenDetails }) => {

      const [openOfferId, setOpenOfferId] = useState(null);

      const toggleOffer = (id) => {
        setOpenOfferId((prev) => (prev === id ? null : id));
      };

    if (!analysis) return null;

    const newBaseUrl = "https://estbn.com/EstbnNew/public";

  return (
    <>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex justify-content-center align-items-center">
          <h6 className="fw-bold mb-0">analysis #{analysis?.request_id}</h6>
          <div className="ms-4 d-flex justify-content-center align-items-center">
            <img src={analysis.current_status.image_url} alt="" />
            <p
              className="my-0 mx-1"
              style={{ color: analysis.current_status.color }}
            >
              {analysis.current_status.key}
            </p>
          </div>
        </div>
        <IconButton onClick={() => setOpenDetails(false)}>
          <Cancel />
        </IconButton>
      </div>
      <Divider />
      {/* Customer Info */}
      <div className="mt-3 row d-flex justify-content-between align-items-start drawer-info">
        <div className="col-6 gap-2 d-flex flex-column">
          <span>Client Name</span>
          <div className=" d-flex align-items-center">
            <img
              src={
                analysis?.customer?.profile_photo
                  ? `${newBaseUrl}${analysis?.customer?.profile_photo}`
                  : client
              }
              alt=""
            />
            <p className="mx-2">{analysis?.customer?.name}</p>
          </div>
          <span>Time</span>
          <p>{analysis?.created_at}</p>
          <span>Expiry Date</span>
          <p>{analysis?.expiry_info?.expires_at}</p>
        </div>
        <div className="col-6 gap-2 d-flex flex-column pt-1">
          <span>Mobile Number</span>
          <div>
            <p>{analysis?.customer?.phone_number}</p>
          </div>
          <span>Maintenance</span>
          <p>{analysis?.category?.name}</p>
        </div>
      </div>
      <Divider className="my-3" />
      {/* Offers */}
      <div className="offers-wrapper">
        {analysis.price_plan_offers?.map((offer) => {
          const isOpen = openOfferId === offer.id;
          const isAccepted = offer.status === "accepted";

          return (
            <div
              key={offer.id}
              className={`offer-card ${isOpen ? "open" : ""} ${
                isAccepted ? "accepted" : ""
              }`}
            >
              {/* Header */}
              <div
                className="offer-header"
                onClick={() => toggleOffer(offer.id)}
              >
                {/* LEFT */}
                <div className="offer-left">
                  <img
                    src={`${newBaseUrl}${offer.image_url}`}
                    alt=""
                    className="offer-icon"
                  />
                  <div className="offer-info">
                    <span className="offer-name">{offer.name}</span>
                    <span
                      className={`offer-status ${
                        isAccepted ? "accepted-status" : ""
                      }`}
                    >
                      {offer.status_label}
                    </span>
                  </div>
                </div>
                {/* RIGHT */}
                <div className="offer-right">
                  <span className="offer-price">
                    {offer.final_price.toLocaleString()} EGP
                  </span>
                  {isOpen ? <ExpandLess /> : <ExpandMore />}
                </div>
              </div>
              {/* Body */}
              {isOpen && (
                <div className="offer-body">
                  {offer.services.map((service) => (
                    <div key={service.id} className="service-row">
                      <div className="service-col">
                        <span className="label">Type</span>
                        <span className="value">{service.name}</span>
                      </div>
                      <div className="service-col">
                        <span className="label">Service Price</span>
                        <span className="value">{service.total_price} EGP</span>
                      </div>
                      {service.products.length > 0 && (
                        <div className="service-col">
                          <span className="label">Service Product</span>
                          <div className="d-flex justify-content-between align-items-center">
                            <span className="value">
                              {service.products[0]?.name}
                            </span>
                            <span className="value bold">
                              {service.products[0]?.total_price} EGP
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default RequestProfile;